// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35zmi","tabsBox":"styles_tabsBox__2r92a","createButton":"styles_createButton__1ZQ1r"};